import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`button {
    cursor: pointer;
    align-items: center;
    color: var(--inv-button-contained-color, #fff);
    font-family: var(--inv-font-family, 'Inter');
    font-size: var(--inv-button-font-size, 1em);
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    text-align: center;
    display: flex;
    flex-direction: row;
    gap: 0.5em;
    justify-content: center;
    padding: 0.75em 1.6em;
    background: var(
        --inv-button-contained-background,
        linear-gradient(93.64deg, #00d5e0 1%, #15a6da 26.85%, #004bba 86.58%, #0f4595 99.6%)
    );
    border-radius: var(--inv-button-contained-border-radius, 1.8em);
    border: none;
}

button:hover:enabled {
    background: var(--inv-button-contained-hover-background, #0e4dab);
}

button:disabled {
    opacity: 0.4;
    cursor: auto;
}

:host(.outlined) > button {
    color: var(--inv-button-outlined-color, #0e4dab);
    border: 0.1em solid transparent;
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)),
        var(
            --inv-button-outlined-background,
            linear-gradient(93.64deg, #00d5e0 1%, #15a6da 26.85%, #004bba 86.58%, #0f4595 99.6%)
        );
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 0.1em 1000px 0.05em #fff inset;
}

:host(.outlined) > button:hover:enabled {
    background: var(--inv-button-outlined-hover-background, #0e4dab);
}

:host(.large) > button {
    padding: 0.84375em 2em;
}

:host(.medium) > button {
    padding: 0.59375em 1.5em;
}

:host(.small) > button {
    padding: 0.66666em 1.33333em;
    border-radius: var(--inv-button-outlined-border-radius, 2.33em);
}

:host(.full-width) > button {
    width: 100%;
}
`); export default styleSheet;